/** 官网 — 服务条款页 */
export const ClauseService = {
  badge: '服务条款',
  pageTitle: '课堂派服务条款',
  pageSubtitle: '请仔细阅读以下服务条款，您的使用即表示接受本协议',
  footerTitle: '如有任何疑问',
  footerDesc: '如您对本服务条款有任何问题或建议，请随时联系我们的客服团队',
  footerContact: '联系我们',

  s0_title: '合约定义',
  s0_i0:
    '本网站（本合约中一律指ketangpai.com）由北京爱课互动科技有限公司（以下简称"爱课互动公司"）所有和运作。',
  s0_i1:
    '本合约是网站用户(包括个人、企业及其他组织)与网站运营企业爱课互动公司之间的法律契约。用户访问、浏览和注册本网站即代表接受本合约条款的约束，用户对本网站的访问和使用应以接受并遵守本合约所载明的条款和条件为前提。',

  s1_title: '知识产权申明',
  s1_i0:
    '本网站的包括但不限于应用程序、源代码、商标、标示图案(LOGO)、界面设计、应用程序编程接口(API)等所关联的所有知识产权均属爱课互动公司所有。用户不得复制、修改、传播或在非本网站所属的服务器上做镜像或者以其它方式进行非法使用。',
  s1_i1:
    '用户在本网站平台所创建的独创性数据归属该用户所有，该用户有权对前述数据进行任何形式的处置，包括从平台中复制，导出和删除。',
  s1_i2:
    '用户应当确保其公开或存储（方式包括但不限于：上传、保存、公布、发布等）于本网站及相关服务器的内容不存在任何侵犯其他第三方知识产权的情形。若存在本条所述情形，爱课互动公司有权根据具体情节针对上述内容，采取包括但不限于限制、屏蔽、删除、修改等手段，由此给网站用户造成的损失由网站用户自行承担；若爱课互动公司因网站用户存在本条所述行为而向其他第三方承担法律责任的，爱课互动公司有权向网站用户追偿全部损失。',

  s2_title: '网站使用规则',
  s2_i0_text: '不得上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：',
  s2_i0_sub0: '反对宪法所确定的基本原则的；',
  s2_i0_sub1: '危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
  s2_i0_sub2: '损害国家荣誉和利益的；',
  s2_i0_sub3: '煽动民族仇恨、民族歧视、破坏民族团结的；',
  s2_i0_sub4: '破坏国家宗教政策，宣扬邪教和封建迷信的；',
  s2_i0_sub5: '散布谣言，扰乱社会秩序，破坏社会稳定的；',
  s2_i0_sub6: '散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
  s2_i0_sub7: '侮辱或者诽谤他人，侵害他人合法权利的；',
  s2_i0_sub8:
    '含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；',
  s2_i0_sub9: '含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。',
  s2_i1: '不得为任何非法目的而使用网络服务系统；',
  s2_i2_text: '不利用课堂派服务从事以下活动：',
  s2_i2_sub0: '未经允许，进入计算机信息网络或者使用计算机信息网络资源的；',
  s2_i2_sub1: '未经允许，对计算机信息网络功能进行删除、修改或者增加的；',
  s2_i2_sub2:
    '未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；',
  s2_i2_sub3: '故意制作、传播计算机病毒等破坏性程序的；',
  s2_i2_sub4: '其他危害计算机信息网络安全的行为。',

  s3_title: '用户信息保护',
  s3_i0:
    '本网站将尽可能采取一切措施保护用户数据及个人信息资料安全，只根据用户在网站上的行为指示来分发用户的信息，不会向任何第三方公开或共享用户的具体数据。',
  s3_i1:
    '本网站保留使用汇总统计性信息的权利，在不透露单个用户隐私资料的前提下，本网站有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。',

  s4_title: '数据存储与清理规则',
  s4_i0:
    '鉴于本平台长期为广大用户提供免费服务，随着用户规模持续增长，历史数据存储压力日益增大。为保障全体用户的系统使用流畅性与数据读取效率，本平台将在不影响正常教学功能的前提下，有权对课堂作业数据进行不定期归档或删除。<strong>清理范围仅限于学生作业附件</strong>，作业题目、提交时间、教师评语、作业成绩等核心教学数据将完整保留。',
  s4_i1_text: '具体清理规则如下：',
  s4_i1_sub0:
    '<strong>长期未登录用户：</strong>连续1年（365天）未登录本平台的用户，其课堂内相关学生作业附件将不再保留，包括但不限于文档、图片、音视频、压缩文件等各类附件资料；',
  s4_i1_sub1:
    '<strong>正常活跃用户：</strong>近12个月内有登录记录的教师用户，自作业开启时间起，平台默认保留12个月（365天）的学生作业附件。请各位教师用户及时下载并妥善保存所需的作业附件资料。',
  s4_i1_sub2:
    '<strong>账号冻结与数据清理：</strong>对于连续1年（365天）未登录本平台的用户，平台有权对该账号进行冻结，并依照本条款对账号关联数据进行清理（包括但不限于作业附件、冗余缓存数据等）；核心教学记录（作业题目、提交时间、教师评语、成绩等）按既有规则保留。',
  s4_i2: '本平台建议用户定期备份重要数据，以确保教学资料的长期保存与使用。',

  s5_title: '免责申明',
  s5_i0:
    '本网站将尽最大努力保障软件平台的连续可靠运行，但鉴于网络服务的特殊性，本网站对可能发生的网络服务的中断或终止所可能导致的一切损失，不承担任何法律责任及经济赔偿。',
  s5_i1:
    '本网站将尽最大努力保障客户数据的安全备份，但无法承诺100%的数据恢复，对因数据丢失带来的任何直接或间接损失不承担任何责任。',
  s5_i2:
    '在发生需要从备份文件中恢复数据的情形时，本网站通常需要4小时，最长48小时完成，在此时间范围内的数据恢复视作服务是连续的。',
  s5_i3:
    '对于因不可抗力或本网站不能控制的原因造成的网络服务中断和长时间终止，本网站不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。',

  s6_title: '合约变更',
  s6_i0: '本网站有权随时对本合约的条款进行修订，一旦本合约的内容发生变更，本网站将会在修订生效日前一个工作日更新。',
  s6_i1: '如用户继续使用网络服务，则视为用户接受本网站对合约相关条款所做的修订。',

  s7_title: '其他',
  s7_i0: '本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。',
  s7_i1:
    '如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向课堂派所在地的人民法院提起诉讼。',
}
